import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: resolve => require(['@/views/home'], resolve),
    meta: {
      title: 'Cheers 上线速览',
      requiresAuth: true
    }
  },
  {
    path: '/',
    name: 'index',
    component: resolve => require(['@/views/index'], resolve),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/package',
    name: 'PackageManage',
    component: () => import('@/views/package/index.vue'),
    meta: {
      title: '安装包管理',
      requiresAuth: true
    }
  },
  {
    path: '/package/upload/:type',
    name: 'PackageUpload',
    component: () => import('@/views/package/upload.vue'),
    meta: {
      title: '安装包上传',
      requiresAuth: true
    }
  },
  {
    path: '/package/list',
    name: 'PackageList',
    component: () => import('@/views/package/list.vue'),
    meta: {
      title: '发版记录管理',
      requiresAuth: true
    }
  },
  {
    path: '/wechatCallback',
    name: 'wechatCallback',
    component: () => import('@/views/wechatCallback.vue'),
    meta: {
      title: '登录授权中...',
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
